import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import {
  ReminderListResponse,
  ReminderCountResponse,
  ReminderCreateResponse,
  ReminderActionResponse,
  CreateReminderRequest,
  ReminderStatus
} from '../interfaces/reminder.interface';

@Injectable({
  providedIn: 'root'
})
export class ReminderService extends BaseHttpService {

  getMyReminders(): Observable<ReminderListResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken();
    }
    return this.get<ReminderListResponse>('/reminders/my');
  }

  getMyUpcomingReminders(): Observable<ReminderListResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken();
    }
    return this.get<ReminderListResponse>('/reminders/my/upcoming');
  }

  getMyReminderCount(): Observable<ReminderCountResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken();
    }
    return this.get<ReminderCountResponse>('/reminders/my/count');
  }

  createReminder(data: CreateReminderRequest): Observable<ReminderCreateResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }
    return this.post<ReminderCreateResponse>('/reminders/', data);
  }

  updateReminderStatus(reminderId: number, status: ReminderStatus): Observable<ReminderActionResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }
    return this.put<ReminderActionResponse>(`/reminders/${reminderId}/status`, { status });
  }

  updateReminderTime(reminderId: number, reminderTime: string): Observable<ReminderActionResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }
    return this.put<ReminderActionResponse>(`/reminders/${reminderId}/time`, { reminder_time: reminderTime });
  }

  deleteReminder(reminderId: number): Observable<ReminderActionResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }
    return this.delete<ReminderActionResponse>(`/reminders/${reminderId}`);
  }
}
